define([], function() {
  var b64u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"   // base64url dictionary
  var b64pad = '='

  function base64_encode_data(data, len, b64x) {
    var dst = ""
    var i

    for (i = 0; i <= len - 3; i += 3)
    {
        dst += b64x.charAt(data.charCodeAt(i) >>> 2)
        dst += b64x.charAt(((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i+1) >>> 4))
        dst += b64x.charAt(((data.charCodeAt(i+1) & 15) << 2) | (data.charCodeAt(i+2) >>> 6))
        dst += b64x.charAt(data.charCodeAt(i+2) & 63)
    }

    if (len % 3 == 2)
    {
        dst += b64x.charAt(data.charCodeAt(i) >>> 2)
        dst += b64x.charAt(((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i+1) >>> 4))
        dst += b64x.charAt(((data.charCodeAt(i+1) & 15) << 2))
        dst += b64pad
    }
    else if (len % 3 == 1)
    {
        dst += b64x.charAt(data.charCodeAt(i) >>> 2)
        dst += b64x.charAt(((data.charCodeAt(i) & 3) << 4))
        dst += b64pad
        dst += b64pad
    }

    return dst
  }

  function base64url_encode(str) {
    var utf8str = unescape(encodeURIComponent(str))

    return base64_encode_data(utf8str, utf8str.length, b64u).replace(/=/g, '')
  }

  function base64_charIndex(c) {
    if (c == "+") return 62
    if (c == "/") return 63

    return b64u.indexOf(c)
  }

  function base64_decode(data) {
    var dst = ""
    var i, a, b, c, d, z

    for (i = 0; i < data.length - 3; i += 4) {
      a = base64_charIndex(data.charAt(i+0))
      b = base64_charIndex(data.charAt(i+1))
      c = base64_charIndex(data.charAt(i+2))
      d = base64_charIndex(data.charAt(i+3))

      dst += String.fromCharCode((a << 2) | (b >>> 4))
      if (data.charAt(i+2) != b64pad)
        dst += String.fromCharCode(((b << 4) & 0xF0) | ((c >>> 2) & 0x0F))
      if (data.charAt(i+3) != b64pad)
        dst += String.fromCharCode(((c << 6) & 0xC0) | d)
    }

    dst = decodeURIComponent(escape(dst))
    return dst
  }

  return {
    encode: base64url_encode,
    decode: base64_decode,
  };
});
